import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=c2643656&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
import style0 from "./Signup.vue?vue&type=style&index=0&id=c2643656&prod&scoped=true&lang=css"
import style1 from "./Signup.vue?vue&type=style&index=1&id=c2643656&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2643656",
  null
  
)

export default component.exports